import * as React from "react";
import { useEffect } from "react";
import { useStore } from "stores/connect";
import LicenseTrafficViolationNotification from "./LicenseTrafficViolationNotification";
import { LicenseTrafficViolationActions, LicenseTrafficViolationStore } from "../LicenseTrafficViolationStore";
const _loadTrafficViolation = () => {
  LicenseTrafficViolationActions.getTrafficViolation();
};
const LicenseTrafficViolationNotificationContainer = () => {
  const { acknowledged } = useStore(LicenseTrafficViolationStore);
  useEffect(() => _loadTrafficViolation(), []);
  const acknowledgeViolationNotification = () => {
    LicenseTrafficViolationActions.acknowledgeTrafficViolation();
  };
  const shouldShowNotification = acknowledged !== void 0 && !acknowledged;
  return /* @__PURE__ */ React.createElement("div", null, shouldShowNotification && /* @__PURE__ */ React.createElement(LicenseTrafficViolationNotification, { onDismissNotification: acknowledgeViolationNotification }));
};
export default LicenseTrafficViolationNotificationContainer;
